<template>
  <div class="landing-box">
      <div class="hero-content">
          <h1 class="hero-title">Create your very own <span class="gradient-text">MSDAT</span></h1>
          <p class="hero-subtitle">
              Build a powerful, customized health data dashboard in minutes.
              Visualize, analyze, and share your data with the world.
          </p>

          <div class="cta-group">
            <router-link :to="{ path: '/configure/account', query: { view: 'signup' } }">
                <button class="btn-glass primary">
                    Get Started <i class="fas fa-arrow-right ml-2"></i>
                </button>
            </router-link>

            <p class="login-text">
                Already have an account?
                <router-link :to="{ path: '/configure/account', query: { view: 'login' } }" class="login-link">Sign In</router-link>
            </p>
          </div>
      </div>

      <!-- Decorative Elements -->
      <div class="glass-decoration card-1">
          <i class="fas fa-chart-pie"></i>
          <span>Analytics</span>
      </div>
      <div class="glass-decoration card-2">
          <i class="fas fa-database"></i>
          <span>Data</span>
      </div>
  </div>
</template>

<script>
import { RouterLink } from 'vue-router';

export default {
  components: {
    RouterLink,
  },
};
</script>

<style lang="scss" scoped>
.landing-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%; // Takes full height of container
  min-height: 80vh;
  position: relative;
  overflow: hidden;
}

.hero-content {
    text-align: center;
    position: relative;
    z-index: 2;
    max-width: 800px;
    padding: 2rem;
}

.hero-title {
  font-size: 3.5rem;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  color: #2c3e50;
  letter-spacing: -1px;

  @media (max-width: 768px) {
      font-size: 2.5rem;
  }
}

.gradient-text {
    background: linear-gradient(135deg, #007D53 0%, #348481 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.hero-subtitle {
    font-size: 1.25rem;
    color: #57606f;
    margin-bottom: 3rem;
    line-height: 1.6;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
}

.cta-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
}

.btn-glass {
    position: relative;
    padding: 16px 48px;
    font-size: 1.1rem;
    font-weight: 600;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid rgba(255, 255, 255, 0.4);

    &.primary {
        background: rgba(0, 125, 83, 0.9);
        color: white;
        box-shadow: 0 8px 32px 0 rgba(0, 125, 83, 0.3);

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 12px 40px 0 rgba(0, 125, 83, 0.4);
            background: #007D53;
        }
    }
}

.login-text {
    font-size: 1rem;
    color: #57606f;
}

.login-link {
    color: #007D53;
    font-weight: 600;
    text-decoration: none;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 100%;
        height: 2px;
        background: #007D53;
        transform: scaleX(0);
        transition: transform 0.3s ease;
    }

    &:hover::after {
        transform: scaleX(1);
    }
}

// Decorative Floating Cards
.glass-decoration {
    position: absolute;
    background: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.5);
    padding: 1rem;
    border-radius: 16px;
    display: flex;
    align-items: center;
    gap: 0.8rem;
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05);
    animation: float-card 6s infinite ease-in-out;
    z-index: 1;

    i {
        font-size: 1.5rem;
        color: #007D53;
    }

    span {
        font-weight: 600;
        color: #2c3e50;
    }
}

.card-1 {
    top: 20%;
    left: 10%;
    animation-delay: 0s;
}

.card-2 {
    bottom: 20%;
    right: 10%;
    animation-delay: 2s;
}

@keyframes float-card {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-20px); }
}
</style>
